//https://github.com/taketwo/glasbey

export default {
    '_55': [
        '#2dbbfb',
'#8530f9',
'#ff47af',
'#e9bd03',
'#04ae61',
'#af1024',
'#0060CF',
'#808080',
'#BC7F1E',
'#e99595',
'#8880D0',
'#b7cb50',
'#a45254',
'#515151',
'#e5622d',
'#2fc6d0',
'#9cfa52',
'#FFB732',
'#63131e',
'#541482',
'#d66e5c',
'#81b2ef',
'#69c427',
'#c96ccc',
'#8a8484',
'#c92b14',
'#424171',
'#7FDFE1',
'#e69553',
'#513B35',
'#d6d378',
'#c200ae',
'#004ec9',
'#cf3729',
'#bce80e',
'#0722b0',
'#AD510C',
'#CFAF0A',
'#f95691',
'#677032',
'#7f5d4d',
'#1D2F4E',
'#e76d78',
'#9ac1b1',
'#914440',
'#ff6021',
'#423786',
'#12e3bb',
'#185203',
'#b83235',
'#086d68',
'#8a44c7',
'#FE9A7A',
'#3e5570',
'#80A6CF',
'#72132A',
'#ffd041',
'#F7BCB5',
'#AA568C',
'#689e33',
'#fa465e',
'#1EE34E',
'#2cadb3',
'#1a1ae8',
'#FC304B',
'#85d4b0',
'#AD0C61',
'#6D79D9',
'#d1b98c',
'#00b99a',
'#4f49a3',
'#9ac914',
'#bfbcf4',
'#DB2E45',
'#141861',
'#008a83',
'#e3a21e',
'#333a61',
'#ea345a',
'#c98c77',
'#427AC7',
'#b9e8a0',
'#bf4354',
'#8fa245',
'#94798c',
'#041680',
'#447e32',
'#3d1606',
'#51adc5',
'#ab8627',
'#8a4c00',
'#51b837',
'#9C138C',
'#D68604',
'#315B6B',
'#ad5757',
'#81a374',
'#AB0782',
'#005427',
'#0e9dcc',
'#2dbbfb',
'#8530f9',
'#ff47af',
'#e9bd03',
'#04ae61',
'#af1024',
'#0060CF',
'#808080',
'#BC7F1E',
'#e99595',
'#8880D0',
'#b7cb50',
'#a45254',
'#515151',
'#e5622d',
'#2fc6d0',
'#9cfa52',
'#FFB732',
'#63131e',
'#541482',
'#d66e5c',
'#81b2ef',
'#69c427',
'#c96ccc',
'#8a8484',
'#c92b14',
'#424171',
'#7FDFE1',
'#e69553',
'#513B35',
'#d6d378',
'#c200ae',
'#004ec9',
'#cf3729',
'#bce80e',
'#0722b0',
'#AD510C',
'#CFAF0A',
'#f95691',
'#677032',
'#7f5d4d',
'#1D2F4E',
'#e76d78',
'#9ac1b1',
'#914440',
'#ff6021',
'#423786',
'#12e3bb',
'#185203',
'#b83235',
'#086d68',
'#8a44c7',
'#FE9A7A',
'#3e5570',
'#80A6CF',
'#72132A',
'#ffd041',
'#F7BCB5',
'#AA568C',
'#689e33',
'#fa465e',
'#1EE34E',
'#2cadb3',
'#1a1ae8',
'#FC304B',
'#85d4b0',
'#AD0C61',
'#6D79D9',
'#d1b98c',
'#00b99a',
'#4f49a3',
'#9ac914',
'#bfbcf4',
'#DB2E45',
'#141861',
'#008a83',
'#e3a21e',
'#333a61',
'#ea345a',
'#c98c77',
'#427AC7',
'#b9e8a0',
'#bf4354',
'#8fa245',
'#94798c',
'#041680',
'#447e32',
'#3d1606',
'#51adc5',
'#ab8627',
'#8a4c00',
'#51b837',
'#9C138C',
'#D68604',
'#315B6B',
'#ad5757',
'#81a374',
'#AB0782',
'#005427',
'#0e9dcc'
]
};